import { products } from "../../data/products";

export const Footer = () => {
  const productCount = products.length;
  return (
  <footer
    data-testid="site-footer"
    className="relative bg-[#050403] border-t border-[#1A1411] pt-24 sm:pt-32 pb-12"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-12">
      <h3 className="font-[Playfair_Display] text-[#FDF8F5] text-5xl sm:text-6xl lg:text-8xl font-medium leading-[1] tracking-tight">
        Produse Alimentare
        <br />
        <em className="italic text-[#C8A97E]">En Gross.</em>
      </h3>

      <div className="mt-20 grid grid-cols-1 sm:grid-cols-3 gap-10 border-t border-[#1A1411] pt-12">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#6B5E55] mb-3">Contact</p>
          <p className="text-[#B8AC9F] text-sm font-light">+40 700 000 000</p>
          <p className="text-[#B8AC9F] text-sm font-light">contact@produse-engross.ro</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#6B5E55] mb-3">Sediu</p>
          <p className="text-[#B8AC9F] text-sm font-light">București, România</p>
          <p className="text-[#B8AC9F] text-sm font-light">L–V: 09:00 – 18:00</p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#6B5E55] mb-3">Catalog</p>
          <p className="text-[#B8AC9F] text-sm font-light">{productCount}+ produse</p>
          <p className="text-[#B8AC9F] text-sm font-light">Marinate · Dulciuri · Vinuri</p>
        </div>
      </div>

      <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-[#1A1411] pt-8">
        <p className="text-xs text-[#6B5E55] tracking-wide">
          © 2026 Produse Alimentare En Gross. Toate drepturile rezervate.
        </p>
        <p className="text-xs text-[#6B5E55] tracking-[0.2em] uppercase">
          Distribuitor B2B · România
        </p>
      </div>
    </div>
  </footer>
  );
};
